import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDuas } from "../Types/IDuas";

export interface IDuasState {
  duas: IDuas[];
}

export const initialState: IDuasState = {
  duas: [],
};

export const DuasSlice = createSlice({
  initialState,
  name: "Duas",
  reducers: {
    setDuas: (state: IDuasState, { payload }: PayloadAction<IDuas[]>): void => {
      state.duas = payload;
    },
  },
});

export const duasActions = DuasSlice.actions;

export const duasReducer = DuasSlice.reducer;
